export default __webpack_public_path__ + "static/media/csv.74b36623.svg";